// itemDetails is the Redux resources store name for all storage target item details requests.
export const itemDetails = 'storage/item';

// items is the Redux resources store name for all storage target items requests.
export const items = 'storage/items';
